module.exports = __webpack_public_path__ + "img/lounge.b95c9ff4.jpg";